


























































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import NimiqButton from '@/components/NimiqButton.vue';
import LearnMore from '@/components/LearnMore.vue';
import JoinMailer from '@/components/JoinMailer.vue';

@Component({
  components: { NimiqButton, LearnMore, JoinMailer },
})
export default class Home extends Vue {
  inputCurrency = 'eur';
  outputCurrency = 'nim';
  updateInterval = 0;
  pairs: Array<any> = [];
  latestSwap: any;

  selectCurrency(inCurrency: string, outCurrency: string) {
    const notSame = (c: string, o: string): string => (c !== o ? o : (o === 'eur' ? 'nim' : 'eur'));
    if (inCurrency) {
      this.inputCurrency = inCurrency;
      this.outputCurrency = notSame(inCurrency, this.outputCurrency);
    } else {
      this.outputCurrency = outCurrency;
      this.inputCurrency = notSame(outCurrency, this.inputCurrency);
    }
  }

  created() {
    this.updateStats();
    this.updateInterval = setInterval(this.updateStats.bind(this), 20000);
  }

  beforeDestroy() {
    clearInterval(this.updateInterval);
  }

  async updateStats() {
    // this.pairs = (await (await fetch('https://stats.fastspot.io/pairs.json')).json()) as Array<any>;
    this.pairs = (await (await fetch('https://stats.fastspot.io/v2/tickers')).json()) as Array<any>;
    [this.latestSwap] = this.pairs;
    this.pairs.forEach((pair) => { if (pair.last_time > this.latestSwap.last_time) this.latestSwap = pair; });
  }

  /* eslint-disable */
  format(num: number, fiat = false): string {
    if (typeof num === 'string') num = parseFloat(num);
    if (num > 1000) return Math.ceil(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\'').trim();
    if (num > 1) return num.toFixed(2);
    if (num < 0.00001) return num.toFixed(10);
    return num.toLocaleString();
  }
  /* eslint-enable */
}
